import styles from './statsBox.module.scss';
import { Box, Typography } from '@mui/material';

const StatsBox = ({ formattedValue, label, Icon, color }) => {
    return (
        <Box className={styles.statsBox}>
            <div className={styles.iconWrapper} style={{ backgroundColor: color }}>
                <Icon />
            </div>
            <Typography
                fontSize="38px"
                fontFamily={'InstrumentSans-semibold'}
                sx={{ lineHeight: 'normal', letterSpacing: '-0.76px' }}
                mb="8px"
                align="center">
                {formattedValue}
            </Typography>
            <Typography
                align="center"
                sx={{ opacity: 0.5, letterSpacing: '-0.16px', lineHeight: '100%' }}>
                {label}
            </Typography>
        </Box>
    );
};

export default StatsBox;
